module.exports = __webpack_public_path__ + "static/media/article1.661b286a.jpg";